import { isRecurringPurchase } from './multiPrice';

/**
 * Whether a variant option's price should carry the "for N payments" badge.
 * Prices-first sibling of shouldShowVariantOptionInterval: gate on the SELECTED
 * price's cadence (isRecurringPurchase), on a recurring option, with a payment
 * plan (planIterations > 1). The legacy product.type fallback lives inside
 * isRecurringPurchase.
 * TODO(M14): the legacy fallback is removed after the prices[] backfill has run.
 */
export default function shouldShowVariantPlanIterations({ selectedPrice, product, option, planIterations }) {
  if (!isRecurringPurchase(selectedPrice, product)) return false;
  if (option?.type !== 'recurring') return false;
  return planIterations > 1;
}
